import React, { useEffect } from 'react'
import { AppDispatch } from './store'
import { useDispatch, useSelector } from 'react-redux'

import { initializeAuth } from './store/authSlice'
import { RootState } from './store/rootReducer'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './views/Login'
import PrivateRoute from './components/PrivateRoute'

import { ping } from './api/account'
import Page from './components/Page'
import Applications from './views/Applications'
import Application from './views/Application'
import Placements from './views/Placements'
import Placement from './views/Placement'
import Home from './views/Home'
import CreateApplication from './views/CreateApplication'

function App(): React.ReactElement | null {
  const dispatch = useDispatch<AppDispatch>()
  const { authToken, isLoadingAuth } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    dispatch(initializeAuth())
  }, [dispatch])

  useEffect(() => {
    const interval = setInterval(() => {
      if (authToken) {
        ping()
      }
    }, 120000)
    return () => clearInterval(interval)
  }, [authToken])

  if (isLoadingAuth) {
    return null
  }

  return (
    <Router>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Page>
          <PrivateRoute path="/skraumsokn" exact>
            <CreateApplication />
          </PrivateRoute>
          <PrivateRoute path="/umsoknir" exact>
            <Applications />
          </PrivateRoute>
          <PrivateRoute path="/umsokn/:id" exact>
            <Application />
          </PrivateRoute>
          <PrivateRoute path="/breytaumsokn/:id" exact>
            <CreateApplication />
          </PrivateRoute>
          <PrivateRoute path="/skraningar" exact>
            <Placements />
          </PrivateRoute>
          <PrivateRoute path="/skraning/:id" exact>
            <Placement />
          </PrivateRoute>
          <PrivateRoute path="/" exact>
            <Home />
          </PrivateRoute>
        </Page>
      </Switch>
    </Router>
  )
}

export default App
